import { Box, Button, Dialog, Flex, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { ErrorOutlineIcon } from 'shared/icons';

type SavedJobConfirmDialogProps = {
   title: string;
   message: string;
   loading?: boolean;
   confirmLabel: string;
   cancelLabel: string;
   onConfirm: () => void;
};

const SavedJobConfirmDialogView = ({
   title,
   message,
   loading = false,
   confirmLabel,
   cancelLabel,
   onConfirm,
}: SavedJobConfirmDialogProps) => {
   return (
      <Box className="saved-job-confirm-dialog">
         <Flex justify="center">
            <Text color="red">
               <ErrorOutlineIcon width={80} height={80} />
            </Text>
         </Flex>

         <Flex justify="center" direction="column" align="center" mt="5" mb="6">
            <Dialog.Title aria-describedby={undefined}>
               <Text color="gray" highContrast size="7">
                  {title}
               </Text>
            </Dialog.Title>

            <Text color="gray">{message}</Text>
         </Flex>

         <Flex justify="center" gap="3">
            <Button color="red" size="3" loading={loading} onClick={onConfirm}>
               {confirmLabel}
            </Button>

            <Dialog.Close>
               <Button color="gray" size="3">
                  {cancelLabel}
               </Button>
            </Dialog.Close>
         </Flex>
      </Box>
   );
};

export const SavedJobConfirmDialog = observer(SavedJobConfirmDialogView);
